import type { CompletionFragment } from './planner.graphql.generated';
import { LESSON, ASSESSMENT } from 'global/constants';
import type { GetPlannerItemGroupByUnitQuery } from './planner.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export const PLANNER_BLURB = `Planner is your new favourite teaching tool, with everything you need to teach in one place. Save time and effortlessly manage your teaching program.`;

export const POLL_INTERVAL_LONG = 10000;

export const ALL_TERMS_WORD = 'all';
export const ALL_TERMS = 0;
export const TERMS = [
  { label: 'Term 1', value: 1 },
  { label: 'Term 2', value: 2 },
  { label: 'Term 3', value: 3 },
  { label: 'Term 4', value: 4 },
];
export const ALL_TERM_OPTIONS = [
  { label: 'All Terms', value: ALL_TERMS },
  ...TERMS,
];

export type PlannerDetailType = {
  id: number;
  plannerItemGroupId: number;
  position: number;
  parentId: number;
};

export const defaultPlannerDetail = {
  id: 0,
  plannerItemGroupId: 0,
  type: null,
  position: 1,
  parentId: 0,
};

export const PLANNER_QUERY_PARAM_SUBJECTS = 'subjects';
export const PLANNER_QUERY_PARAM_SUGGESTED = 'suggested-units';
export const PLANNER_SIDEDRAW_DETAILS_PARAMS = {
  sb: '1',
};
export const PLANNER_SIDEDRAW_ADD_UNIT_PARAMS = {
  sb: '1',
  tab: PLANNER_QUERY_PARAM_SUBJECTS,
};

export const GO_TO = 'goTo';
export const MOVE_UNIT = 'moveUnit';
export const REMOVE_UNIT = 'removeUnit';
export const REMOVE_ITEM = 'removeItem';
export const COPY_LINK = 'copyLink';
export const DOWNLOAD_PROGRAM = 'downloadProgram';
export const MOVE_UP = 'moveUp';
export const MOVE_DOWN = 'moveDown';

export type PlannerItemLesson = Pluck<
  GetPlannerItemGroupByUnitQuery,
  'getPlannerItemGroupByUnit.plannerItemLessons'
>;
export type PlannerItemAssessment = Pluck<
  GetPlannerItemGroupByUnitQuery,
  'getPlannerItemGroupByUnit.plannerItemAssessments'
>;
export type PlannerItem = PlannerItemLesson | PlannerItemAssessment;

export type PlannerContentItemBase = {
  id: number;
  type: typeof LESSON | typeof ASSESSMENT;
};

export type PlannerContentItem = PlannerContentItemBase & {
  name: string;
  completion: CompletionFragment | null;
  isBookmarked: boolean;
  isAnnotated: boolean;
};

export type PlannerContentItemAndPlannerItem = PlannerContentItemBase & {
  plannerItemId: number;
};
